// extracted by mini-css-extract-plugin
export var boldText = "_60-4";
export var checkboxContainer = "_60-6";
export var closeIcon = "_60-i";
export var container = "_60-0";
export var drawer = "_60-8";
export var drawerContent = "_60-9";
export var extraSmallText = "_60-5";
export var fulfillmentGroupTable = "_60-e";
export var largeText = "_60-3";
export var loadingSpinnerContainer = "_60-j";
export var mediumText = "_60-2";
export var narrow = "_60-f";
export var notificationLink = "_60-l";
export var packageCheckIconContainer = "_60-7";
export var slideoutHeaderActions = "_60-g";
export var slideoutHeaderActionsShifted = "_60-h";
export var slideoutHeaderContainer = "_60-a";
export var slideoutModal = "_60-c";
export var stickyHeaderWrapper = "_60-b";
export var table = "_60-k";
export var tableContainer = "_60-d";
export var tertiaryText = "_60-1";